import { useCapabilities } from './CapabilityProvider';

export default function PermissionLoadError() {
  const { refreshCapabilities, isUnauthorized } = useCapabilities();
  return (
    <section role="alert" style={{ padding: 'var(--spacing-8)' }}>
      <h2>Unable to load permissions</h2>
      <p>{isUnauthorized ? 'Access was denied while checking permissions. Retry if your access has changed.' : 'We could not confirm your access. Try again to continue.'}</p>
      <button type="button" onClick={() => { refreshCapabilities().catch(() => {}); }}>
        Retry permissions
      </button>
    </section>
  );
}
